function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 .95C4.286.95.45 4.786.45 9.5S4.286 18.05 9 18.05s8.55-3.836 8.55-8.55S13.714.95 9 .95zm0 15.938c-4.074 0-7.388-3.314-7.388-7.388S4.926 2.112 9 2.112s7.387 3.314 7.387 7.388S13.074 16.887 9 16.887z",
  fill: "#70544F",
  stroke: "#70544F",
  strokeWidth: 0.1
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#70544F",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  d: "M9.102 6.023v3.552M12.418 12.116l-3.419-2.093"
});

function SvgClock2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgClock2;